export default __webpack_public_path__ + "static/media/clear.b94d8cf6.svg";